var _excluded = ["escapeHTML", "transformItems", "hitComponent", "bannerComponent"],
  _excluded2 = ["hit", "index"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { createHitsComponent } from 'instantsearch-ui-components';
import React, { createElement, Fragment } from 'react';
import { useHits } from 'react-instantsearch-core';
// @MAJOR: Move default hit component back to the UI library
// once flavour specificities are erased
function DefaultHitComponent(_ref) {
  var hit = _ref.hit;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      wordBreak: 'break-all'
    }
  }, JSON.stringify(hit).slice(0, 100), "\u2026");
}
var HitsUiComponent = createHitsComponent({
  createElement: createElement,
  Fragment: Fragment
});
export function Hits(_ref2) {
  var escapeHTML = _ref2.escapeHTML,
    transformItems = _ref2.transformItems,
    _ref2$hitComponent = _ref2.hitComponent,
    HitComponent = _ref2$hitComponent === void 0 ? DefaultHitComponent : _ref2$hitComponent,
    BannerComponent = _ref2.bannerComponent,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useHits = useHits({
      escapeHTML: escapeHTML,
      transformItems: transformItems
    }, {
      $$widgetType: 'ais.hits'
    }),
    hits = _useHits.hits,
    banner = _useHits.banner,
    sendEvent = _useHits.sendEvent;
  var itemComponent = function itemComponent(_ref3) {
    var hit = _ref3.hit,
      index = _ref3.index,
      itemProps = _objectWithoutProperties(_ref3, _excluded2);
    return /*#__PURE__*/React.createElement("li", _extends({
      key: hit.objectID
    }, itemProps), /*#__PURE__*/React.createElement(HitComponent, {
      hit: hit,
      sendEvent: sendEvent
    }));
  };
  var bannerComponent = BannerComponent === false ? function () {
    return null;
  } : BannerComponent;
  var uiProps = {
    hits: hits,
    sendEvent: sendEvent,
    itemComponent: itemComponent,
    banner: banner,
    bannerComponent: bannerComponent
  };
  return /*#__PURE__*/React.createElement(HitsUiComponent, _extends({}, props, uiProps));
}